"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isLocationSearchResult = exports.StoreFinderType = void 0;
var StoreFinderType;
(function (StoreFinderType) {
    StoreFinderType[StoreFinderType["CLICK_AND_COLLECT"] = 1] = "CLICK_AND_COLLECT";
    StoreFinderType[StoreFinderType["IN_STORE_FILTER"] = 2] = "IN_STORE_FILTER";
    StoreFinderType[StoreFinderType["LOCATOR"] = 3] = "LOCATOR";
    StoreFinderType[StoreFinderType["BASKET"] = 4] = "BASKET";
    StoreFinderType[StoreFinderType["CHECKOUT"] = 5] = "CHECKOUT";
})(StoreFinderType || (exports.StoreFinderType = StoreFinderType = {}));
function isLocationSearchResult(value) {
    return value.type !== undefined;
}
exports.isLocationSearchResult = isLocationSearchResult;
//# sourceMappingURL=LocationTypes.js.map